/**
 * Material Selector view.
 *
 * Dictates behavior and interaction for material selector elements
 *
 *
 */

var ShapewaysView = require('./ShapewaysView');
var $ = require('./../../sw-jquery/sw-jquery');
var _ = require('underscore');
var sw = require('js/lib/sw');
var productPageActionsCreators = require('js/lib/actions/ProductViewPage/actionCreators');
var materialDropdownOption = require('rrTags/product_sets/templates/tpl.product-material-dropdown-option.mustache');
var materialDropdownOptgroup = require('rrTags/product_sets/templates/tpl.product-material-dropdown-optgroup.mustache');

var MaterialSelector = ShapewaysView.extend({

  swAttrs: {
    swatchChoice: 'data-sw-material-choice-id'
  },

  events: function() {

    var eventsHash = {
      'click [data-sw-material-swatch]': 'onSwatchClick',
      'change [data-sw-material-selector-dropdown]': 'onDropdownChange',
      'mouseenter [data-sw-material-dropdown-option]': 'previewPConfImageInBigSlideshow',
      /* Must use elements since Selectric generates these elements */
      'mouseleave ul:not([class*="group"])': 'returnBigSlideshowToPreviousState',
      'mouseenter li[class*="group"]': 'returnBigSlideshowToPreviousState'
    };

    var modernizrTouch = document.documentElement.classList.contains('touch'); //replace Modernizr API

    if (modernizrTouch) {
      eventsHash['click [data-sw-material-swatch-summary-prefix]'] = 'onSwatchTouch';
    } else {
      eventsHash['mouseenter [data-sw-material-swatch-summary-prefix]'] = 'swatchEnter';
      eventsHash['mouseleave [data-sw-material-swatch-summary-prefix]'] = 'swatchLeave';
    }

    return eventsHash;
  },

  initialize: function(options) {
    this.productDimensionInstanceId = options.productDimensionInstanceId;

    this.listenTo(this.model, 'change:currentConfigurationId', this.repaint, this);
    this.listenTo(this.model, 'change:currentConfigurationId', this.updateMaterialDropdown, this);
  },

  onSwatchClick: function(e) {
    var $swatch = $(e.currentTarget);

    this.updateChoiceFromElement($swatch);
  },

  onDropdownChange: function(e) {
    var $selectedOption = $(e.currentTarget).find(':selected');

    this.updateChoiceFromElement($selectedOption);
  },

  updateChoiceFromElement: function($el) {
    if ($el.swIsDisabled()) {
      return;
    }

    var choiceId = $el.data('swMaterialChoiceId');

    this.model.updateChoice(this.productDimensionInstanceId, choiceId);
  },

  renderDropdownOptions: function(choices) {
    var model = this.model,
        productDimensionInstanceId = this.productDimensionInstanceId,
        currentChoice = model.getCurrentChoice(productDimensionInstanceId).productDimensionChoiceId;
    var renderedDropdownOptionsHtml = _.reduce(choices, function(dropdownOptionsHtml, choice) {
      var choiceId = choice.productDimensionChoiceId,
          pConfId = model.getProductConfigurationIdForInstanceIdAndChoiceId(productDimensionInstanceId, choiceId),
          pConf = model.getProductConfiguration(pConfId),
          price = pConf.formattedTotalPrice,
          materialName = choice.materialShopperTitle,
          mustacheView = {
            isActivePConf: true,
            isDefault: choiceId === currentChoice,
            swatchUrl: choice.materialShopperSwatch,
            materialChoice: {
              getShopperTitle: materialName,
              getId: choice.materialId
            },
            getProductConfigurationPrice: price,
            getSwatchConfigurationId: pConfId,
            product: {
              getSpin: model.attributes.spin
            },
            summaryPrefix: materialName,
            productDimensionInstanceId: productDimensionInstanceId,
            materialFamily: {
              getId: choice.materialShopperFamilyId
            },
            choiceId: choiceId
          };
      return dropdownOptionsHtml + materialDropdownOption.render(mustacheView);
    }, '');
    return renderedDropdownOptionsHtml;
  },

  renderDropdownOptgroups: function(choicesByMaterialFamily) {
    var _this = this,
        model = this.model,
        productDimensionInstanceId = this.productDimensionInstanceId,
        productDimension = model.getProductDimensionFromDimensionInstanceId(productDimensionInstanceId);
    var renderedDropdownHtml = _.reduce(choicesByMaterialFamily, function(newDropdownHtml, choices, displayShopperFamilyId) {
      if(!displayShopperFamilyId){
        return newDropdownHtml;
      }
      var displayShopperFamily = _.find(productDimension.displayShopperFamilies, function(displayShopperFamily) {
            return parseInt(displayShopperFamily.displayShopperFamilyId, 10) === parseInt(displayShopperFamilyId, 10);
          }),
          displayShopperFamilyName = displayShopperFamily.displayShopperFamilyName;

      var dropdownOptionsHtml = _this.renderDropdownOptions(choices);

      var mustacheView = {
        displayName: displayShopperFamilyName,
        materialSummaryPrefix: displayShopperFamilyId,
        renderMaterialDropdownOptions: dropdownOptionsHtml
      };

      return newDropdownHtml + materialDropdownOptgroup.render(mustacheView);
    }, '');
    return renderedDropdownHtml;
  },

  updateMaterialDropdown: function() {
    var model = this.model,
        productDimensionInstanceId = this.productDimensionInstanceId;

    // If this ProductDimension triggered the changed, we do not need to update the dropdown
    if (!model.isOtherProductDimensionInstanceChange(productDimensionInstanceId)) {
      return;
    }

    var productDimension = model.getProductDimensionFromDimensionInstanceId(productDimensionInstanceId),
        productDimensionChoices = productDimension.productDimensionChoices,
        choiceIds = model.getChoicesForDimensionInstance(productDimensionInstanceId);

    var choicesByMaterialFamily = _.reduce(choiceIds, function(choicesByMaterialFamily, choiceId) {
        var choice = productDimensionChoices[choiceId];
        if (_.isUndefined(choicesByMaterialFamily[choice.displayShopperFamilyId])) {
          choicesByMaterialFamily[choice.displayShopperFamilyId] = [choice];
        } else {
          choicesByMaterialFamily[choice.displayShopperFamilyId].push(choice);
        }
        return choicesByMaterialFamily;
    }, {});

    var newDropdownHtml = this.renderDropdownOptgroups(choicesByMaterialFamily);

    this.$el.find('[data-sw-material-selector-dropdown]').html(newDropdownHtml);

  },

  _getAvailableChoicesSelector: function() {
    var choiceIds = this.model.getChoicesForDimensionInstance(this.productDimensionInstanceId);

    return _.map(choiceIds, function(choiceId) {
      return this.makeAttributeValueSelector(this.swAttrs.swatchChoice, choiceId);
    }, this).join(',');
  },

  render: function() {
    var choice = this.model.getCurrentChoice(this.productDimensionInstanceId);

    this.$('.swatch-selected').removeClass('swatch-selected');
    this.$('[data-sw-material-id="' + choice.valInt + '"]').addClass('swatch-selected');

    var availableChoices = this._getAvailableChoicesSelector();
    this.cachedElements.$swatchChoice.swDisable().swFindWithSelf(availableChoices).swEnable();
  },

  getSwatchChoice: function($swatch) {
    var productDimensionInstanceId = $swatch.data('swMaterialDimensionInstanceId');
    var materialId = $swatch.data('swMaterialId');

    return this.model.getChoiceByInstanceIdAndMaterialId(productDimensionInstanceId, materialId);
  },

  previewPConfImageInBigSlideshow: function(e) {
    var $el = $(e.currentTarget),
      choiceId = $el.attr(this.swAttrs.swatchChoice);

    if (_.isUndefined(choiceId)) {
      return;
    }
    var previewPicture = this.model.getPicturePreviewDataForInstanceIdAndChoice(this.productDimensionInstanceId, choiceId);
    if (_.isNull(previewPicture)) {
      this.returnBigSlideshowToPreviousState();
      return;
    }

    sw.dispatch(productPageActionsCreators.previewMainImageSlideshow(previewPicture.pConfPictureUrl,
        previewPicture.pConfPictureCaption, previewPicture.isShapewaysMaterialRender));
  },

  returnBigSlideshowToPreviousState: function() {
    sw.dispatch(productPageActionsCreators.previewMainImageSlideshow());
  },

  swatchEnter: function(e) {
    this.updateAndShowMaterialFamilySummary(e);
  },

  /**
   * On touch devices, update the material family summary
   * with the click/touch event.
   *
   * @param e
   */
  onSwatchTouch: function(e) {
    this.updateAndShowMaterialFamilySummary(e);
  },

  /**
   * Change the material family name and show the
   * name above the swatches.
   *
   * @param e
   */
  updateAndShowMaterialFamilySummary: function(e) {
    var modernizrTouch = document.documentElement.classList.contains('touch'); //replace Modernizr API

    if (modernizrTouch) {
      this.clearSummary();
    }

    var $swatch = $(e.currentTarget);
    var $summary = this.$('[data-sw-material-selector-material-info="' + $swatch.data('swMaterialSwatchFamilyId') + '"]');
    var $colon = this.$('[data-sw-material-selector-family-colon="' + $swatch.data('swMaterialSwatchFamilyId') + '"]');

    var choice = this.getSwatchChoice($swatch);

    if (choice && choice.materialId) {

      $colon.swShow();
      $summary.text(choice.materialShopperTitle);
    }
  },

  swatchLeave: function() {
    this.clearSummary();
  },

  clearSummary: function() {
    this.$('[data-sw-material-selector-material-info]').text('');
    this.$('[data-sw-material-selector-family-colon]').swHide();
  }

});

module.exports = MaterialSelector;
